export const AuthenticationRoutes = {
  Login: 'login',
  Registration: 'registration',
  JoinOrganization: 'join-organization',
  LinkedInRedirect: 'linkedin-redirect',
} as const;
